$(".js-language").on("click", function () {
    $(this).closest(".language").toggleClass("_opened");
    $(this).closest(".language-head").toggleClass("_opened");
});

App.D.mouseup(function (e) {
    let dropdown = $(".language");
    let popup = $(".js-popup");

    if (
        dropdown.hasClass("_opened") &&
        !dropdown.is(e.target) &&
        dropdown.has(e.target).length === 0
    ) {
        dropdown.removeClass("_opened");
    }

    if (
        popup.hasClass("_active") &&
        !popup.is(e.target) &&
        popup.has(e.target).length === 0 &&
        !$(e.target).closest('.select2-dropdown').length &&
        !$(e.target).closest('.iti__country-list').length
    ) {
        popup.removeClass("_active");
        App.H.removeClass("_overlay");
    }
});

App.D.mouseup(function (e) {
    let dropdown = $(".language-head");
    let popup = $(".js-popup");

    if (
        dropdown.hasClass("_opened") &&
        !dropdown.is(e.target) &&
        dropdown.has(e.target).length === 0
    ) {
        dropdown.removeClass("_opened");
    }

    if (
        popup.hasClass("_active") &&
        !popup.is(e.target) &&
        popup.has(e.target).length === 0 &&
        !$(e.target).closest('.select2-dropdown').length &&
        !$(e.target).closest('.iti__country-list').length
    ) {
        popup.removeClass("_active");
        App.H.removeClass("_overlay");
    }
});
